import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10b91b78&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=10b91b78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b91b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b91b78')) {
      api.createRecord('10b91b78', component.options)
    } else {
      api.reload('10b91b78', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10b91b78&scoped=true", function () {
      api.rerender('10b91b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/itemConfig/index.vue"
export default component.exports